import { OrderItemSerializable } from './order-item-serializable';

export class LoyaltyCreditOrderItemSerializable extends OrderItemSerializable {
  loyaltyCreditsAmount: number;
  modifiesTotal = false;
  productId: number = null;
  productProductTypeParentProductTypeId: number = null;
  productTypeId: number = null;
  productName: string = null;
  productAmount: number = null;
}
